/**
 * FooterCopyright - Copyright notice
 */

import { companyInfo } from '../../lib'

export function FooterCopyright() {
  return (
    <p className="text-left text-white font-poppins text-xs xl:text-sm">
      © {new Date().getFullYear()} - {companyInfo.name}
    </p>
  )
}
